import { render, staticRenderFns } from "./AvailableColorsTabs.vue?vue&type=template&id=4894dfcc&scoped=true"
import script from "./AvailableColorsTabs.vue?vue&type=script&lang=js"
export * from "./AvailableColorsTabs.vue?vue&type=script&lang=js"
import style0 from "./AvailableColorsTabs.vue?vue&type=style&index=0&id=4894dfcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894dfcc",
  null
  
)

export default component.exports